import { render, staticRenderFns } from "./bao-cao-doanh-thu.vue?vue&type=template&id=704ab96d&"
import script from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports